<template>
  <v-toolbar elevation="0" class="mr-0 transparent">
    <v-btn
      :disabled="entityListSelected.length < 1 || buildIsClosed"
      @click="navigateToBatchEdit"
      class="mr-3"
      color="primary"
      data-cy="batchEdit"
      outlined
      small
      text
      >Edit Batch ({{ entityListSelected.length }})</v-btn
    >

    <dialog-export
      :entity-list="entityListSelected"
      :entity-name="entityName"
      v-if="entityListSelected.length"
    >
      <template v-slot:default="{ on }">
        <v-btn
          color="primary"
          outlined
          small
          v-if="entityListSelected.length"
          v-on="on"
          >Export ({{ entityListSelected.length }})</v-btn
        >
        <v-btn v-else outlined small color="primary" v-on="on"
          >Export All</v-btn
        >
      </template>
    </dialog-export>

    <dialog-export
      :entityList="entityListFiltered"
      :entityName="entityName"
      v-else
    >
      <template v-slot:default="{ on }">
        <v-btn outlined small color="primary" v-on="on">Export All</v-btn>
      </template>
    </dialog-export>

    <v-spacer></v-spacer>

    <dialog-import-history class="mr-3"></dialog-import-history>

    <v-btn
      :disabled="buildIsClosed"
      :to="{ name: `${entityName}ImportFile` }"
      class="mr-3"
      color="primary"
      data-cy="listTable-actions-import"
      outlined
      small
      >import</v-btn
    >

    <v-btn
      :disabled="buildIsClosed"
      :to="{ name: `${entityName}Create` }"
      color="primary"
      data-cy="listTable-actions-add"
      outlined
      small
      v-if="userCanCreateEntity"
      >Add</v-btn
    >
  </v-toolbar>
</template>

<script>
import { get } from "lodash";
import { mapState } from "vuex";
import { toBase64 } from "@/lib/stringUtil";
import DialogExport from "@/views/build/user/components/DialogExport";
import DialogImportHistory from "@/views/build/user/components/DialogImportHistory";

export default {
  components: {
    DialogExport,
    DialogImportHistory,
  },
  computed: {
    entityPermissionMap() {
      const { entityName } = this;
      return get(this, `session.user.permission.${entityName}`);
    },
    userCanCreateEntity() {
      const { entityPermissionMap } = this;

      const { create } = entityPermissionMap;
      return create;
    },
    ...mapState({
      session: state => state.session,
    }),
  },
  methods: {
    navigateToBatchEdit() {
      const { $router, entityName, idAttributeName, entityListSelected } = this;

      const idListString = entityListSelected
        .map(entity => entity[idAttributeName])
        .join(",");
      const idListEncoded = toBase64(idListString);

      const name = `${entityName}EditBatch`;

      $router.push({ name, params: { idListEncoded } });
    },
  },
  props: {
    buildIsClosed: {
      default: false,
      type: Boolean,
    },
    entityListFiltered: {
      required: true,
      type: Array,
    },
    entityListSelected: {
      required: true,
      type: Array,
    },
    entityName: {
      required: true,
      type: String,
    },
    idAttributeName: {
      required: true,
      type: String,
    },
  },
};
</script>
